import axios from 'axios'
export default {
    // 获取缓存数据
    getJson(url, key) {
        return new Promise((resolve, reject) => {
            const cookiesKey = `zzbCosWPA${key}`,
                data = localStorage.getItem(cookiesKey)
            if (data) {
                resolve(JSON.parse(data))
            } else {
                axios.get(url).then(res => {
                    localStorage.setItem(cookiesKey, JSON.stringify(res.data))
                    resolve(res.data)
                })
            }
        })
    },
    // 加载缓存数据
    load(cacheData) {
        const {
            key
        } = cacheData,
        cookiesKey = `zzbCosWPA${key}`,
            data = localStorage.getItem(cookiesKey);
        if (data) {
            cacheData.data = JSON.parse(data);
        }
    },
    // 向缓存的数组数据中写入新数据
    push(cacheData, data) {
        const {
            key,
            max = 6,
            keyName = 'name'
        } = cacheData,
        checkValue = data[keyName],
            cookiesKey = `zzbCosWPA${key}`,
            // 过滤掉重复数据
            list = cacheData.data.filter(item => {
                return item[keyName] != checkValue;
            });
        // 检查数据是否已存在
        // 如果数组长度大于最大长度，移除最后一条数据
        if (list.length >= max) {
            list.pop();
        }
        // 写入新数据
        list.unshift(data);
        // 设置新数据
        cacheData.data = list;
        // 缓存数据
        localStorage.setItem(cookiesKey, JSON.stringify(list));
    },
    // 清空缓存数据
    removeAll(cacheData, defaultValue = []) {
        const {
            key
        } = cacheData,
        cookiesKey = `zzbCosWPA${key}`;
        localStorage.setItem(cookiesKey, '');
        cacheData.data = defaultValue;
    }
}